<form name="theForm" novalidate class="general-form">
    <ng-container *ngIf="policytype !== page.mobilehome">
        <div> <!-- Year Built -->
            <label 
                for="txt-year-built"
                [class.visible-label]="isMobileDevice()">
                {{'HOMEOWNERS.QUESTIONS.YEAR_BUILT_PLACEHOLDER' | translate }}
            </label>
            <div class="input-group mb-4">
                <input
                    id="txt-year-built"
                    name="yearbuilt"
                    type="text"
                    class="form-control"
                    [ngClass]="{'has-error' : quoterRequestError.YearBuiltIsEmpty || quoterRequestError.YearBuiltIsOutsideOfRange}"
                    placeholder="{{'HOMEOWNERS.QUESTIONS.YEAR_BUILT_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}"
                    attr.aria-label="{{'HOMEOWNERS.QUESTIONS.YEAR_BUILT_PLACEHOLDER' | translate}}"
                    [(ngModel)]="quoterRequest.YearBuilt"    
                    (keyup)="checkBuildYear($event)"            
                    numbersOnly
                    />            
                <span class="input-group-text input-group-text-required" aria-hidden="true">*</span> 
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.YearBuiltIsEmpty">
                {{yearBuiltisEmptyMessage}}
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.YearBuiltIsOutsideOfRange">
                {{yearBuiltErrorMessage}}
            </div>
        </div>

        <div> <!-- Insured Value -->
            <label
                for="txt-insured-value"
                [class.visible-label]="isMobileDevice()">
                {{'HOMEOWNERS.QUESTIONS.INSURED_VALUE_PLACEHOLDER' | translate }}
            </label>
            <div class="input-group mb-4">
                <input 
                    id="txt-insured-value" 
                    name="insuredvalue"                    
                    type="text"
                    placeholder="{{'HOMEOWNERS.QUESTIONS.INSURED_VALUE_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}"
                    class="form-control"
                    [class]="{'has-error': quoterRequestError.InsuredValueIsEmpty || quoterRequestError.InsuredValueOutOfRange || quoterRequestError.InsuredValueOutOfRangeHigh}"
                    [(ngModel)]="quoterRequest.InsuredValue"
                    (keyup)="checkInsuredValue($event)"
                    attr.aria-label="{{'HOMEOWNERS.QUESTIONS.INSURED_VALUE_PLACEHOLDER' | translate}}"
                    numbersOnly
                     />
                <app-cea-help-button 
                    [stype]="'input'"
                    [title]="'HOMEOWNERS.QUESTIONS.HELP.INSURED_VALUE.TITLE'"
                    [text1]="'HOMEOWNERS.QUESTIONS.HELP.INSURED_VALUE.TEXT'">
                </app-cea-help-button>
                <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>
            </div>
            <div class="alert alert-danger" 
                *ngIf="quoterRequestError.InsuredValueIsEmpty"
                [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
            </div>
            <div class="alert alert-danger" 
                *ngIf="quoterRequestError.InsuredValueOutOfRange"
                [innerHTML]="'ERRORS.VALID_INSURED_VALUES' | translate">
            </div>
            <div class="alert alert-danger" 
                *ngIf="quoterRequestError.InsuredValueOutOfRangeHigh"
                [innerHTML]="'ERRORS.VALID_INSURED_MAX_EXCEEDED' | translate">
            </div>
        </div>

        <div> <!-- Number of Stories  -->
            <label 
                for="ddl-number-of-stories"
                [class.visible-label]="isMobileDevice()">
                {{'HOMEOWNERS.QUESTIONS.STORIES_PLACEHOLDER' | translate}}
            </label>
            <div class="input-group mb-4">
                <select 
                    id="ddl-number-of-stories"
                    class="form-select"
                    [class]="{'has-error' : quoterRequestError.numberOfStoriesIsNotSelected}"
                    name="numberofstories"
                    [(ngModel)]="quoterRequest.numberOfStories"
                    attr.aria-label="{{'HOMEOWNERS.QUESTIONS.STORIES_PLACEHOLDER' | translate}}"
                    (change)="checkForHRD()">
                    <option [ngValue]="-1" disabled *ngIf="!isRff2025()">
                        {{'HOMEOWNERS.QUESTIONS.STORIES_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}
                    </option>
                    <option [ngValue]="-1" disabled *ngIf="isRff2025()">
                        {{'HOMEOWNERS.QUESTIONS.STORIES_PLACEHOLDER_RFF2025' | ceaPlaceholder: !isMobileDevice() | translate }}
                    </option>
                    <option [ngValue]="0" title="{{'HOMEOWNERS.QUESTIONS.STORIES.STORIES_SINGLE' | translate }}">
                        {{'HOMEOWNERS.QUESTIONS.STORIES.STORIES_SINGLE' | translate }}
                    </option>
                    <option [ngValue]="1" title="{{'HOMEOWNERS.QUESTIONS.STORIES.STORIES_GREATER_THAN_ONE' | translate }}">
                        {{'HOMEOWNERS.QUESTIONS.STORIES.STORIES_GREATER_THAN_ONE' | translate }}
                    </option>
                </select>
                <app-cea-help-button 
                    *ngIf="!isRff2025()"
                    [stype]="'input'"
                    [title]="'HOMEOWNERS.QUESTIONS.HELP.NUMBER_OF_STORIES.TITLE'"
                    [text1]="'HOMEOWNERS.QUESTIONS.HELP.NUMBER_OF_STORIES.TEXT'">
                </app-cea-help-button>
                <app-cea-help-button 
                    *ngIf="isRff2025()"
                    [stype]="'input'"
                    [title]="'HOMEOWNERS.QUESTIONS.HELP.NUMBER_OF_STORIES.TITLE'"
                    [text1]="'HOMEOWNERS.QUESTIONS.HELP.NUMBER_OF_STORIES.TEXT_RFF2025'">
                </app-cea-help-button>
                <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.numberOfStoriesIsNotSelected"
                [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
            </div>
        </div>

        <div> <!-- Foundation Type -->
            <label 
                for="ddl-foundation-type"
                [class.visible-label]="isMobileDevice()">
                {{'HOMEOWNERS.QUESTIONS.FOUNDATION_PLACEHOLDER' | translate }}
            </label>
            <div class="input-group mb-4">
                <select
                    id="ddl-foundation-type"
                    name="foundationtype"
                    class="form-select"
                    [class]="{'has-error': quoterRequestError.foundationTypeVariableIsNotSelected}"
                    (change)="checkForHRD()"
                    [(ngModel)]="quoterRequest.foundationTypeVariable"
                    attr.aria-label="{{'HOMEOWNERS.QUESTIONS.FOUNDATION_PLACEHOLDER' | translate}}"
                    (ngModelChange)="checkForHRD($event, 'foundationTypeVariable')">
                    <option [ngValue]="-1" disabled>
                        {{'HOMEOWNERS.QUESTIONS.FOUNDATION_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}
                    </option>
                    <option [ngValue]="i" *ngFor="let item of foundationTypeVariableOptions; let i = index">
                        {{ item }}
                    </option>
                </select>
                <app-cea-help-button 
                    [stype]="'input'"
                    [title]="'HOMEOWNERS.QUESTIONS.HELP.FOUNDATION.TITLE'"
                    [text1]="'HOMEOWNERS.QUESTIONS.HELP.FOUNDATION.TEXT'"
                    [text2]="'HOMEOWNERS.QUESTIONS.HELP.FOUNDATION.IMAGE'">
                </app-cea-help-button>
                <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.foundationTypeVariableIsNotSelected"
                [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
            </div>
        </div>

        <div *ngIf="quoteApplicationSettings.showRoofDropdown">  <!-- Roof Type -->
            <label
                for="ddl-roof-type"
                [class.visible-label]="isMobileDevice()">
                {{'HOMEOWNERS.QUESTIONS.ROOF_TYPE_PLACEHOLDER' | translate }}
            </label>
            <div class="input-group mb-4">
                <select
                    id="ddl-roof-type"
                    class="form-select"
                    name="rooftype"
                    [class]="{'has-error' : quoterRequestError.roofTypeVariableIsNotSelected && quoteApplicationSettings.showRoofDropdown}"
                    (change)="checkForHRD()"
                    [(ngModel)]="quoterRequest.roofTypeVariable"
                    attr.aria-label="{{'HOMEOWNERS.QUESTIONS.ROOF_TYPE_PLACEHOLDER' | translate}}">
                    <option [ngValue]="-1" disabled>
                        {{'HOMEOWNERS.QUESTIONS.ROOF_TYPE_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}
                    </option>
                    <option [ngValue]="i" *ngFor="let item of roofTypeVariableOptions; let i = index">
                        {{ item }}
                    </option>
                </select>
                <app-cea-help-button 
                    *ngIf="!isRff2025()"
                    [stype]="'input'"
                    [title]="'HOMEOWNERS.QUESTIONS.HELP.ROOF_TYPE.TITLE'"
                    [text1]="'HOMEOWNERS.QUESTIONS.HELP.ROOF_TYPE.TEXT'">
                </app-cea-help-button>
                <app-cea-help-button 
                    *ngIf="isRff2025()"
                    [stype]="'input'"
                    [title]="'HOMEOWNERS.QUESTIONS.HELP.ROOF_TYPE.TITLE'"
                    [text1]="'HOMEOWNERS.QUESTIONS.HELP.ROOF_TYPE.TEXT_RFF2025'">
                </app-cea-help-button>
                <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.roofTypeVariableIsNotSelected && quoteApplicationSettings.showRoofDropdown"
                [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
            </div>
        </div>

        <div> <!-- Frame Construction -->
            <fieldset class="question-fieldset mb-4">
                <legend class="question-legend">
                    <span *ngIf="isMobileDevice()">
                        {{'HOMEOWNERS.QUESTIONS.FRAME_CONSTRUCTION_MOBILE' | translate }}
                    </span>
                    <span *ngIf="!isMobileDevice()">
                        {{'HOMEOWNERS.QUESTIONS.FRAME_CONSTRUCTION' | translate }}
                    </span>
                </legend>
                <div class="question-fieldset-content d-flex justify-content-end">
                    <div class="form-check form-check-inline">
                        <input
                            id="rad-frame-construction-yes"
                            class="form-check-input"
                            type="radio"
                            [name]="'radiogroup' + groupkey"
                            [(ngModel)]="quoterRequest.IsWoodFrame"
                            [value]="true"
                            checked
                            (change)="checkForHRD()" />
                            <label 
                                for="rad-frame-construction-yes"
                                class="form-check-label">
                                {{'GLOBAL.YES' | translate }}
                            </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            id="rad-frame-construction-no"
                            class="form-check-input"
                            type="radio"
                            [name]="'radiogroup' + groupkey"
                            [(ngModel)]="quoterRequest.IsWoodFrame"
                            [value]="false" 
                            (change)="checkForHRD()"/>
                            <label 
                                for="rad-frame-construction-no"
                                class="form-check-label">
                                {{'GLOBAL.NO' | translate }}
                            </label>
                    </div>
                    <app-cea-help-button 
                        [stype]="'radio'"
                        [title]="'HOMEOWNERS.QUESTIONS.HELP.WOODFRAME.TITLE'"
                        [text1]="'HOMEOWNERS.QUESTIONS.HELP.WOODFRAME.TEXT'">
                    </app-cea-help-button>
                </div>
            </fieldset>
        </div>

        <div *ngIf="showHrdDiscount"> <!-- HRD Blurb -->
            <div class="cea-standout-container mb-4">
                <h3 class="cea-standout-text">
                    <span *ngIf="!isHrdOptions()">
                        {{'HOMEOWNERS.HRD.OVERVIEW' | translate }}
                    </span>
                    <span *ngIf="isHrdOptions()">
                        {{'HOMEOWNERS.HRD.OVERVIEW_1M_UNDER' | translate }}
                    </span>
                </h3>
            </div>
            <div *ngIf="quoterRequest.StartYear >= 2016" class="mb-4">
                <p class="text-primary fw-bold">
                    {{'HOMEOWNERS.HRD.FEATURES_TEXT' | translate }}
                </p>
                <ol>
                    <li>
                        {{'HOMEOWNERS.HRD.FEATURE_1' | translate }}
                        <span class="text-primary fw-bold">
                            {{'HOMEOWNERS.HRD.AND' | translate }}
                        </span>
                    </li>
                    <li>
                        {{'HOMEOWNERS.HRD.FEATURE_2' | translate }}
                        <span class="text-primary fw-bold">
                            {{'HOMEOWNERS.HRD.AND' | translate }}
                        </span>
                    </li>
                    <li>
                        <p style="padding-right: 4rem;">
                            {{'HOMEOWNERS.HRD.FEATURE_3' | translate }}
                            <span class="text-primary fw-bold">
                                {{'HOMEOWNERS.HRD.FEATURE_3_OR' | translate }}
                            </span>
                        </p>
                        <div class="d-flex justify-content-end help-button-higher-up">                                                        
                            <app-cea-help-button 
                                [stype]="'radio'"
                                [title]="'HOMEOWNERS.HELP.HRD_CRIPPLE.TITLE'"
                                [text1]="'HOMEOWNERS.HELP.HRD_CRIPPLE.TEXT'"
                                [text2]="'HOMEOWNERS.HELP.HRD_CRIPPLE.IMAGE'">
                            </app-cea-help-button>
                        </div>
                        <p style="margin-top: -1rem;">
                            {{'HOMEOWNERS.HRD.FEATURE_3A' | translate }}
                        </p>
                    </li>
                </ol>
            </div>            
        </div>

        <div *ngIf="showHrdDiscount" class="mb-4"> <!-- Confirm HRD Yes/No -->
            <div class="d-flex justify-content-between">
                <div>
                    <div class="form-check">
                        <input
                            id="rad-hrd-yes"
                            class="form-check-input"
                            type="radio"
                            name="hrd"
                            [(ngModel)]="quoterRequest.HrdRequirementsConfirmed"
                            [value]="true"/>
                            <label 
                                for="rad-hrd-yes"
                                class="form-check-label">
                                {{'HOMEOWNERS.HRD.RESPONSE_1' | translate }}
                            </label>
                    </div>
                    <div class="form-check">
                        <input
                            id="rad-hrd-no"
                            class="form-check-input"
                            type="radio"
                            name="hrd"
                            [(ngModel)]="quoterRequest.HrdRequirementsConfirmed"
                            [value]="false"
                            checked />
                            <label 
                                for="rad-hrd-no"
                                class="form-check-label">
                                {{'HOMEOWNERS.HRD.RESPONSE_2' | translate }}
                            </label> 
                    </div>
                </div>
                <div style="padding-top: 1rem;">
                    <app-cea-help-button 
                        *ngIf="isHrdOptions()"
                        [stype]="'radio'"
                        [title]="'HOMEOWNERS.HELP.HRD_1M_UNDER.TITLE'"
                        [text1]="'HOMEOWNERS.HELP.HRD_1M_UNDER.TEXT'">
                    </app-cea-help-button>
                    <app-cea-help-button 
                        *ngIf="!isHrdOptions()"
                        [stype]="'radio'"
                        [title]="'HOMEOWNERS.HELP.HRD.TITLE'"
                        [text1]="'HOMEOWNERS.HELP.HRD.TEXT'">
                    </app-cea-help-button>
                </div>
            </div>            
        </div>

        <div *ngIf="showHrdDiscount && quoterRequest.HrdRequirementsConfirmed"> <!-- Confirmed by Engineer Yes/No -->
            <fieldset class="question-fieldset mb-4">
                <legend class="question-legend">
                    {{'HOMEOWNERS.HRD.VERIFIED_BY_ENGINEER' | translate }}
                </legend>
                <div class="question-fieldset-content d-flex justify-content-end">
                    <div class="form-check form-check-inline">
                        <input
                            id="rad-verified-by-engineer-yes"
                            class="form-check-input"
                            type="radio"
                            name="radioGroupHrdRequirementsVerifiedByEngineer"
                            [(ngModel)]="quoterRequest.HrdRequirementsVerifiedByEngineer"
                            [value]="true"
                            (change)="checkForHRD()"
                            checked />
                            <label 
                                for="rad-verified-by-engineer-yes"
                                class="form-check-label">
                                {{'GLOBAL.YES' | translate }}
                            </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            id="rad-verified-by-engineer-no"
                            class="form-check-input"
                            type="radio"
                            name="radioGroupHrdRequirementsVerifiedByEngineer"
                            [(ngModel)]="quoterRequest.HrdRequirementsVerifiedByEngineer"
                            (change)="checkForHRD()"
                            [value]="false" />
                            <label 
                                for="rad-verified-by-engineer-no"
                                class="form-check-label">
                                {{'GLOBAL.NO' | translate }}
                            </label>
                    </div>
                    <app-cea-help-button 
                        [stype]="'radio'"
                        [title]="'HOMEOWNERS.QUESTIONS.HELP.WOODFRAME.TITLE'"
                        [text1]="'HOMEOWNERS.QUESTIONS.HELP.WOODFRAME.TEXT'">
                    </app-cea-help-button>
                </div>
            </fieldset>
        </div>
    </ng-container>

    <ng-container *ngIf="policytype === page.mobilehome">
        <div> <!-- Mobilehome Year Built -->
            <label
                for="txt-year-built"
                [class.visible-label]="isMobileDevice()">
                {{'MOBILEHOME.YEAR_BUILT_PLACEHOLDER' | translate }}
            </label>
            <div class="input-group mb-4">
                <input 
                    id="txt-year-built"
                    name="yearbuilt"
                    type="text"
                    class="form-control"
                    [class]="{'has-error': (quoterRequestError.YearBuiltIsEmpty || quoterRequestError.YearBuiltIsOutsideOfRange) && quoteApplicationSettings.showYearBuilt}"
                    placeholder="{{'MOBILEHOME.YEAR_BUILT_PLACEHOLDER' | ceaPlaceholder: !isMobileDevice() | translate }}" 
                    [(ngModel)]="quoterRequest.YearBuilt"
                    (keyup)="checkBuildYear($event)"
                    attr.aria-label="{{'MOBILEHOME.YEAR_BUILT_PLACEHOLDER' | translate}}"
                    (ngModelChange)="checkForHRD($event, 'yearBuild')"
                    numbersOnly />
                <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.YearBuiltIsEmpty && quoteApplicationSettings.showYearBuilt"
                [innerHTML]="yearBuiltisEmptyMobileErrorMessage">
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.YearBuiltIsOutsideOfRange && quoteApplicationSettings.showYearBuilt"
                [innerHTML]="yearBuiltMobileErrorMessage">
            </div>
        </div>

        <div> <!-- Mobilehome Insured Value -->
            <label
                for="txt-insured-value"
                [class.visible-label]="isMobileDevice()">
                {{'HOMEOWNERS.QUESTIONS.INSURED_VALUE_PLACEHOLDER' | translate }}
            </label>
            <div class="input-group mb-4">
                <input 
                    id="txt-insured-value"
                    name="insuredvalue"
                    type="text"
                    placeholder="{{'HOMEOWNERS.QUESTIONS.INSURED_VALUE_PLACEHOLDER' | ceaPlaceholder: !isMobileView | translate }}"
                    class="form-control"
                    [class]="{'has-error' : quoterRequestError.InsuredValueIsEmpty || quoterRequestError.InsuredValueOutOfRange || quoterRequestError.InsuredValueOutOfRangeHigh }"
                    [(ngModel)]="quoterRequest.InsuredValue"
                    attr.aria-label="{{'HOMEOWNERS.QUESTIONS.INSURED_VALUE_PLACEHOLDER' | translate}}"
                    (ngModelChange)="checkForHRD($event, 'InsuredValue')"
                    (keyup)="checkInsuredValue($event)"
                    numbersOnly />            
                <app-cea-help-button 
                    [stype]="'input'"
                    [title]="'HOMEOWNERS.QUESTIONS.HELP.INSURED_VALUE.TITLE'"
                    [text1]="'HOMEOWNERS.QUESTIONS.HELP.INSURED_VALUE.TEXT'">
                </app-cea-help-button>
                <span class="input-group-text input-group-text-required" aria-hidden="true">*</span>
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.InsuredValueIsEmpty"
                [innerHTML]="'ERRORS.COMPLETE_REQUIRED_FIELDS' | translate">
            </div>
            <div class="alert alert-danger"
                *ngIf="quoterRequestError.InsuredValueOutOfRange"
                [innerHTML]="'ERRORS.VALID_INSURED_VALUES' | translate">
            </div>
            <div class="alert alert-danger" 
                *ngIf="quoterRequestError.InsuredValueOutOfRangeHigh"
                [innerHTML]="'ERRORS.VALID_INSURED_MAX_EXCEEDED' | translate">
            </div>
        </div>

        <div> <!-- Mobilehome Has Bracing -->
            <fieldset class="question-fieldset mb-4">
                <legend class="question-legend">
                    {{'MOBILEHOME.QUESTIONS.HAS_ERBS_QUESTION' | translate}}
                </legend>
                <div class="question-fieldset-content d-flex justify-content-end">
                    <div class="form-check form-check-inline">
                        <input
                            id="rad-bracing-system-yes"
                            class="form-check-input"
                            type="radio"
                            [name]="'radioGroupHasBracingSystem' + groupkey"
                            [(ngModel)]="quoterRequest.HasBracingSystem"
                            [value]="true"
                            checked />
                            <label 
                                for="rad-bracing-system-yes"
                                class="form-check-label">
                                {{'GLOBAL.YES' | translate }}
                            </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            id="rad-bracing-system-no"
                            class="form-check-input"
                            type="radio"
                            [name]="'radioGroupHasBracingSystem' + groupkey"
                            [(ngModel)]="quoterRequest.HasBracingSystem"
                            [value]="false" />
                            <label 
                                for="rad-bracing-system-no"
                                class="form-check-label">
                                {{'GLOBAL.NO' | translate }}
                            </label>
                    </div>
                    <app-cea-help-button 
                        [stype]="'radio'"
                        [title]="'MOBILEHOME.QUESTIONS.HELP.ERBS_QUESTION.TITLE'"
                        [text1]="'MOBILEHOME.QUESTIONS.HELP.ERBS_QUESTION.TEXT'">
                    </app-cea-help-button>
                </div>
            </fieldset>
        </div>

        <ng-container *ngIf="quoteApplicationSettings.showHasInspection">  <!-- Mobilehome Has Inspection -->
            <div *ngIf="quoterRequest.HasBracingSystem">
                <fieldset class="question-fieldset mb-4">
                    <legend class="question-legend"
                        [innerHTML]="'MOBILEHOME.QUESTIONS.HAS_INSPECTION_QUESTION' | translate">
                    </legend>
                    <div class="question-fieldset-content d-flex justify-content-end">
                        <div class="form-check form-check-inline">
                            <input
                                id="rad-has-inspection-yes"
                                class="form-check-input"
                                type="radio"
                                [name]="'radioGroupHasInspection' + groupkey"
                                [(ngModel)]="quoterRequest.HasInspection"
                                [value]="true"
                                checked />
                                <label 
                                    for="rad-has-inspection-yes"
                                    class="form-check-label">
                                    {{'GLOBAL.YES' | translate }}
                                </label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                id="rad-has-inspection-no"
                                class="form-check-input"
                                type="radio"
                                [name]="'radioGroupHasInspection' + groupkey"
                                [(ngModel)]="quoterRequest.HasInspection"
                                [value]="false" />
                                <label 
                                    for="rad-has-inspection-no"
                                    class="form-check-label">
                                    {{'GLOBAL.NO' | translate }}
                                </label>
                        </div>
                        <app-cea-help-button 
                            [stype]="'radio'"
                            [title]="'MOBILEHOME.QUESTIONS.HELP.ERBS_QUESTION.TITLE'"
                            [text1]="'MOBILEHOME.QUESTIONS.HELP.ERBS_QUESTION.TEXT'">
                        </app-cea-help-button>
                    </div>
                </fieldset>
            </div>
        </ng-container>
    </ng-container>

    <div class="row action-buttons">
        <div class="col-12 col-md-6">
            <button class="btn btn-tertiary w-100 mb-3" 
                id="questions-back-btn"
                (click)="goBack()">
                <i class="fas fa-arrow-left" aria-hidden="true"></i>
                {{'GLOBAL.BACK_BUTTON' | translate }}
            </button>            
        </div>
        <div class="col-12 col-md-6">
            <button class="btn btn-tertiary w-100 mb-3" 
                id="questions-get-estimate-btn"
                (click)="submitForm()">
                {{'HOMEOWNERS.QUESTIONS.GET_ESTIMATE_BUTTON' | translate }}
            </button>
        </div>
    </div>
</form>